<div class="flex flex-col gap-4">
  @if (title) {
    <h4 [innerHTML]="title"></h4>
  }
  @if (subTitle) {
    <span class="cd-text-b1 font-normal truncate">{{ subTitle }}</span>
  }
  <h2 [class.italic]="!highlight"
      [class.text-[var(--color-secondary-600)]]="highlight"
      class="cd-text-mono">
    {{ value + ((fraction && hasProgress) ? '/' + target : '') }}
  </h2>
  @if (type) {
    <span class="cd-text-mono font-medium text-3xl truncate">{{ type }}</span>
  }
  @if (description) {
    <span class="cd-text-mono font-medium cd-text-b1 truncate">{{ description }}</span>
  }
</div>

@if (hasProgress) {
  <div class="flex flex-col w-full relative">
    <span [class.progress-inset]="progressInset"
          class="cd-text-b3 truncate">{{ (100 * value / target).toFixed(0) }}% {{ progressLabel }}</span>
    <div class="w-full bg-secondary-300 h-[1.5rem] rounded-[0.75rem] relative">
      <div [style.width]="(100 * value / target).toFixed(0) + '%'"
           class="absolute bg-secondary-600 rounded-[0.75rem] h-[1.5rem] top-0 left-0"></div>
    </div>
  </div>
}

@if (showAction) {
  <button (click)="onClick()" class="btn btn-primary flex flex-row gap-2 items-center"
          style="border-radius: 0.5rem;width:7.625rem;padding: 0.5rem">
    <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/{{icon}}.svg">
    <span class="cd-text-md truncate capitalize">{{ type }}</span>
  </button>
}
